/**
 * @generated SignedSource<<b562ef86ec42de8b693ab3903bf313cb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type layoutHeaderFragment$data = {
  readonly subsections: ReadonlyArray<{
    readonly elements: ReadonlyArray<{
      readonly __typename: string;
    } | null> | null;
  } | null> | null;
  readonly visualConfig: {
    readonly hidden: boolean | null;
  } | null;
  readonly " $fragmentType": "layoutHeaderFragment";
};
export type layoutHeaderFragment$key = {
  readonly " $data"?: layoutHeaderFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"layoutHeaderFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "layoutHeaderFragment",
  "selections": [
    {
      "concreteType": "HelpLayoutSubsection",
      "kind": "LinkedField",
      "name": "subsections",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "name": "elements",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "__typename"
            }
          ]
        }
      ]
    },
    {
      "concreteType": "HelpLayoutVisualConfig",
      "kind": "LinkedField",
      "name": "visualConfig",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "hidden"
        }
      ]
    }
  ],
  "type": "HelpLayoutSection"
};

(node as any).hash = "f703cce131491f9f467281f622f22a23";

export default node;
